<template>
  <div class="page-header level">
    <div class="level-left">
      <div class='size1-text pri-color'>Pool Users</div>
    </div>
  </div>
  <div class="level status-message" v-if="statusMessage && statusMessage.length > 0">
    <div class="level-item">{{statusMessage}}</div>
  </div>
  <div class="level">
    <div class="level-left">
      <div class="page-heading-label level-item">
          Per Page:
      </div>
      <div class="level-item">
        <select v-on:change="onPageSizeChanged()" id="page-size">
            <option value="10" selected="">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="200">200</option>
        </select>
      </div>
    </div>
  </div>
  <ag-grid-vue
      style="width: 100%; height: 600px;"
      class="ag-theme-alpine"
      id="myGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :columnDefs="columnDefs"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :defaultColDef="defaultColDef"
      :modules="modules"
      :rowData="rowData">
  </ag-grid-vue>
  <AreYouSure
    :showModal="requestToResetMFA"
    :message="areYouSureMessage"
    @no="onNotConfirmedMFAReset"
    @yes="onConfirmedMFAReset">
  </AreYouSure>
  <PageLoading :showLoading="!isReady"></PageLoading>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3';
import { AllCommunityModules } from 'ag-grid-community';
import AreYouSure from '@/components/are-you-sure.vue';
import PageLoading from '@/components/page-loading.vue';
import GridUtils from '@/shared/grid-utils';

import * as adminData from '../services/admin-data';

export default {
  name: 'PoolUsers',
  components: {
    AgGridVue,
    AreYouSure,
    PageLoading,
  },
  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      modules: AllCommunityModules,
      rowData: null,
      paginationPageSize: null,
      statusMessage: '',
      userNameToReset: '',
      emailToReset: '',
      isReady: false,
      requestToResetMFA: false,
      areYouSureMessage: 'Are you sure you want to clear this users MFA status?  If you choose Yes, this action cannot be undone.',
    };
  },
  mixins: [GridUtils],
  methods: {
    async fetchGridData() {
      const users = await adminData.default.methods.getPoolUsers();
      this.rowData = users;
    },
    async onGridReady() {
      this.isReady = false;
      await this.fetchGridData();
      this.isReady = true;
    },
    onPageSizeChanged() {
      const ps = document.getElementById('page-size').value;
      this.gridApi.paginationSetPageSize(Number(ps));
    },
    onNotConfirmedMFAReset() {
      this.userNameToReset = '';
      this.emailToReset = '';
      this.requestToResetMFA = false;
    },
    async onConfirmedMFAReset() {
      this.requestToResetMFA = false;
      await this.handleMFAReset();
    },
    resetMFAClicked(username, email) {
      this.userNameToReset = username;
      this.emailToReset = email;
      this.requestToResetMFA = true;
    },
    async handleMFAReset() {
      if (!this.userNameToReset || this.userNameToReset.length < 10) {
        console.error('An error has occurred while being asked to reset an MFA status.');
        return;
      }
      await adminData.default.methods.resetUsersMFAStatus({ userName: this.userNameToReset });
      this.statusMessage = `Your request to reset the MFA status for ${this.emailToReset} has been submitted!`;
      this.userNameToReset = '';
      this.emailToReset = '';
      setTimeout(() => {
        this.statusMessage = '';
      }, 3300);
    },
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      {
        field: 'email',
        headerName: 'Email',
        minWidth: 250,
      },
      {
        field: 'email_verified',
        headerName: 'Email Verified',
      },
      {
        field: 'phone_number',
        headerName: 'Phone',
      },
      {
        field: 'given_name',
        headerName: 'First Name',
      },
      {
        field: 'family_name',
        headerName: 'Last Name',
      },
      {
        field: 'userName',
        headerName: '',
        sortable: false,
        filter: false,
        minWidth: 50,
        cellRenderer: (params) => {
          const link = document.createElement('a');
          link.href = '#';
          link.innerText = 'Reset MFA';
          link.addEventListener('click', (e) => {
            e.preventDefault();
            this.resetMFAClicked(params.value, params.data.email);
            // this.handleMFAReset(params.value);
          });
          return link;
        },
      },
    ];
    this.defaultColDef = {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: 'agTextColumnFilter',
      filterParams: GridUtils.textFilterParams,
      resizable: true,
    };
    this.paginationPageSize = 10;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  computed: {
  },
  props: {
    msg: String,
  },
};

</script>
<style src='ag-grid-community/dist/styles/ag-theme-alpine.css'></style>
<style src='ag-grid-community/dist/styles/ag-grid.css'></style>
<style lang="scss" scoped>
    #export-button {
        font-weight: bold;
    }
    .status-message {
      background-color: green;
      color: #fff;
      min-height: 50px;
    }

@import "~ag-grid-community/src/styles/ag-grid.scss";
@import "~ag-grid-community/src/styles/ag-theme-alpine/sass/ag-theme-alpine-mixin";
.ag-theme-alpine {
    @include ag-theme-alpine((
        // use theme parameters where possible
        header-foreground-color: #FFF,
        header-background-color: #0F3D80,
        font-family: ('Helvetica', 'Arial', 'sans-serif'),
    ));

    .ag-icon {
      color: #FFF;
    }
    .ag-paging-button > .ag-icon {
        color: #000;
    }
    .ag-header-cell-text {
      font-size: 14px;
    }
}

</style>
